import { render } from "./WhyUs.vue?vue&type=template&id=0406fb4d&scoped=true"
const script = {}

import "./WhyUs.vue?vue&type=style&index=0&id=0406fb4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0406fb4d"]])

export default __exports__